import { Link } from 'react-router-dom';

/**
 * The compact "← Home" control that sits at the left of a reader toolbar.
 *
 * It replaced the full-width "← Return to main feed" row: the toolbar already
 * takes a line, so the way back shares it instead of adding another. Pass
 * `to` for a plain navigation, or `onClick` when leaving has to reset page
 * state first (the search results screen). `label` overrides "Home" when the
 * way back is a specific feed rather than the main one.
 */
export function ReaderHomeButton({
  to = '/',
  onClick,
  label = 'Home',
  title = 'Return to main feed',
}: {
  to?: string;
  onClick?: () => void;
  label?: string;
  title?: string;
}) {
  const body = <><span aria-hidden="true">←</span> {label}</>;
  if (onClick) {
    return <button type="button" className="beta-home-btn" title={title} onClick={onClick}>{body}</button>;
  }
  return <Link className="beta-home-btn" to={to} title={title}>{body}</Link>;
}
